import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { PrintServices } from '../../../services/printServices';
import { TPVServices } from '../../../tpv/services';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'page-configuration-printers-native',
  templateUrl: 'configuration-printers-native.html'
})

export class ConfigurationPrintersNativePage {


  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    private printServices: PrintServices,
    public tpvServices: TPVServices,
    public translate: TranslateService) {
  }

  testPrint() {
    this.globals.print_content = document.getElementById('print_native_test');
    var interval = setInterval(() => {
      this.printServices.printNow('print_native_test');
      clearInterval(interval);
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-printers-native/configuration-printers-native.ts